import React, {ReactElement} from 'react';

export const Loader = (): ReactElement => <div className="content__holder">
    <div className="loader"/>
</div>;
